module.exports = __webpack_public_path__ + "static/img/3.1f7949a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/3.jpg
// module id = 0awz
// module chunks = 0